import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';
import { Machine } from "@/models/machine";
import { Maintenance } from "@/models/maintenance";
import { MachinePdf, MachinePdfType } from "@/models/machinePdf";

interface UploadPdfData {
  machine: Machine | null;
  maintenance: Maintenance | null;
}

export default class DocumentPdfRepository extends EntityBaseRepository {
    private readonly BASE_URL = '/pdf';

    public deletePdf(pdf: MachinePdf): Promise<AxiosResponse> {
        return this.axiosClient.delete(`${this.BASE_URL}/${pdf.id}`);
    }

    public downloadPdf(pdf: MachinePdf): Promise<AxiosResponse> {
        return this.axiosClient.get(`${this.BASE_URL}/${pdf.id}`);
    }

    public getPDFDocument(pdf: MachinePdf): Promise<AxiosResponse> {
        return this.axiosClient.get(`${this.BASE_URL}/${pdf.id}`, {
            responseType: "blob"
        });
    }

    public uploadPdf(file: File, pdfType: MachinePdfType, data: UploadPdfData): Promise<AxiosResponse> {
        const formData = new FormData();
        formData.append("pdf", file);

        const params = new URLSearchParams();
        params.append('pdfType', pdfType);

        if (data.machine?.id) {
            formData.append("machine", data.machine.id);
            params.append('machine', data.machine.id);
        }
        
        if (data.maintenance?.id) {
            formData.append("maintenance", data.maintenance.id);
            params.append('maintenance', data.maintenance.id);
        }

        return this.axiosClient.post(`${this.BASE_URL}?${params.toString()}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}
